const DEFAULT = 'en'
function getBrowserLocale(): string {
  if (navigator.languages) return navigator.languages[0]
  return navigator.language
}
// eslint-disable-next-line
function getPrefferedLocal(browserLocale: string, supportedTranslations: Map<any, any>) {
  return supportedTranslations.get(browserLocale)
    ? browserLocale
    : supportedTranslations.get(browserLocale.slice(0, 2))
      ? browserLocale.slice(0, 2)
      : DEFAULT
}

export { getBrowserLocale, getPrefferedLocal }
